import {Component, Input, OnInit} from '@angular/core';
import {ILayoutSettings} from '@app/feature/store-editor/components/layout/store-editor.interface';

@Component({
  selector: 'app-page-setting',
  templateUrl: './page-setting.component.html',
  styleUrls: ['../styling/styling.component.css']
})
export class PageSettingComponent implements OnInit {
  @Input() layoutSettings: ILayoutSettings;
  constructor() { }

  ngOnInit() {
  }

}
